import { gql } from '@apollo/client';
import 'cross-fetch/polyfill';
import { ROUTE_PATTERN_SITEMAP_FILE_REGEX, SITEMAP_STORE_KEY } from '../../constants';
import getHandler from './generic-file-handler';

export const fileQuery = gql`
  query getFiles($where: JSON) {
    files: getFiles(where: $where, limit: 1, sort: [{ property: "created", direction: "desc" }]) {
      mimetype
      url
    }
  }
`;

function getVariables({ asPath }) {
  const filename = asPath.split('/').slice(-1)[0];
  const where = { storeKey: SITEMAP_STORE_KEY, filename };
  return { where };
}

export const pattern = ROUTE_PATTERN_SITEMAP_FILE_REGEX;

export const handler = getHandler(fileQuery, getVariables);
